import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AppShell from "../components/layout/AppShell";
import api, { fmtMoney, fmtDate } from "../lib/api";
import StatusBadge from "../components/StatusBadge";
import { Receipt, ScanSearch, AlertTriangle, Eye, Search, Loader2 } from "lucide-react";
import { Input } from "../components/ui/input";

export default function Invoices() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [q, setQ] = useState("");
    const [match, setMatch] = useState("");
    useEffect(() => { api.get("/invoices").then(r=>setItems(r.data)).finally(()=>setLoading(false)); }, []);

    const filtered = items.filter(i => {
        if (match && i.match_status !== match) return false;
        if (!q) return true;
        const k = q.toLowerCase();
        return (i.number || "").toLowerCase().includes(k)
            || (i.supplier_invoice_number || "").toLowerCase().includes(k)
            || (i.supplier_name || "").toLowerCase().includes(k)
            || (i.po_number || "").toLowerCase().includes(k);
    });

    return (
        <AppShell title="Faturalar & 3'lü Eşleştirme" subtitle="Operasyon">
            <div className="bg-card border border-border rounded-md">
                <div className="p-4 border-b border-border flex items-center gap-3 flex-wrap">
                    <div className="relative w-72">
                        <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground"/>
                        <Input data-testid="inv-search" placeholder="Fatura no, tedarikçi, PO..." value={q} onChange={(e)=>setQ(e.target.value)} className="pl-9"/>
                    </div>
                    <select
                        data-testid="inv-match-filter"
                        className="h-10 border border-input rounded-md px-3 bg-background text-sm"
                        value={match} onChange={(e)=>setMatch(e.target.value)}
                    >
                        <option value="">Tüm eşleşme durumu</option>
                        <option value="matched">Eşleşti</option>
                        <option value="mismatch">Uyumsuz</option>
                        <option value="not_matched">Eşleşmedi</option>
                    </select>
                    <div className="text-xs text-muted-foreground ml-auto flex items-center gap-4">
                        <span>Toplam: {filtered.length}</span>
                        <span className="flex items-center gap-1.5"><span className="w-2 h-2 bg-emerald-500 rounded-full"/> Eşleşti: {filtered.filter(i=>i.match_status==="matched").length}</span>
                        <span className="flex items-center gap-1.5"><span className="w-2 h-2 bg-rose-500 rounded-full"/> Uyumsuz: {filtered.filter(i=>i.match_status==="mismatch").length}</span>
                    </div>
                </div>
                <div className="overflow-x-auto">
                    <table className="data-table">
                        <thead>
                            <tr>
                                <th>No</th><th>Tedarikçi No</th><th>Tarih</th><th>Tedarikçi</th>
                                <th>PO</th><th className="text-right">Tutar</th>
                                <th>Eşleşme</th><th>Durum</th><th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr><td colSpan={9} className="text-center py-16 text-muted-foreground">
                                    <Loader2 size={22} className="mx-auto mb-2 animate-spin opacity-70"/>
                                    Yükleniyor...
                                </td></tr>
                            ) : filtered.map(inv => (
                                <tr key={inv.id} data-testid={`inv-row-${inv.number}`}>
                                    <td className="font-mono text-xs">{inv.number}</td>
                                    <td className="font-mono text-xs">{inv.supplier_invoice_number}</td>
                                    <td>{fmtDate(inv.invoice_date)}</td>
                                    <td className="font-medium">{inv.supplier_name}</td>
                                    <td className="font-mono text-xs">{inv.po_number}</td>
                                    <td className="text-right tabular-nums font-medium">{fmtMoney(inv.total_amount, inv.currency)}</td>
                                    <td>
                                        <div className="flex items-center gap-1.5">
                                            <StatusBadge status={inv.match_status}/>
                                            {inv.discrepancies?.length > 0 && (
                                                <span className="text-xs text-rose-600 flex items-center gap-1">
                                                    <AlertTriangle size={12}/> {inv.discrepancies.length}
                                                </span>
                                            )}
                                        </div>
                                    </td>
                                    <td><StatusBadge status={inv.status}/></td>
                                    <td>
                                        <Link to={`/invoices/${inv.id}`}>
                                            <button className="inline-flex items-center gap-1.5 text-primary text-sm hover:underline" data-testid={`inv-open-${inv.number}`}>
                                                <ScanSearch size={14}/> Eşleştirme
                                            </button>
                                        </Link>
                                    </td>
                                </tr>
                            ))}
                            {!loading && filtered.length === 0 && (
                                <tr><td colSpan={9} className="text-center py-16 text-muted-foreground">
                                    <Receipt size={28} className="mx-auto mb-2 opacity-40"/>
                                    {items.length === 0 ? "Henüz fatura yok" : "Filtreye uyan fatura yok"}
                                </td></tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </AppShell>
    );
}
